import React, { useState, useReducer, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../style/Home.css";
import { Container } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { apiFetchJson } from "../api";

const formReducer = (state, event) => {
    if (event.reset) {
        return {
            studyName: "",
            studyStartDate: undefined,
            studyEndDate: undefined,
        };
    }
    return {
        ...state,
        [event.name]: event.value,
    };
};

const formReducer2 = (state, event) => {
    if (event.reset) {
        return {
            StudyName: "",
            VesselType: "2mm Silicon",
            nSimulations: 0,
        };
    }
    return {
        ...state,
        [event.name]: event.value,
    };
};

const formReducerS = (state, event) => {
    if (event.reset) {
        return {
            StudyName: "",
        };
    }
    return {
        ...state,
        [event.name]: event.value,
    };
};

const AssignStudies = () => {
    const [formData, setFormData] = useReducer(formReducer, {});
    const [formData2, setFormData2] = useReducer(formReducer2, {
        StudyName: "",
        VesselType: "2mm Silicon",
        nSimulations: 0,
    });
    const [checkedTrainees, setCheckedTrainees] = useState([]);
    const [checkedSupervisors, setCheckedSupervisors] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    const [studies, setStudies] = useState([]);
    const [trainees, setTrainees] = useState([]);
    const [supervisors, setSupervisors] = useState([]);

    function refresh() {
        apiFetchJson("/api/info/study")
            .then((data) => {
                const rows = Array.isArray(data?.db) ? data.db : [];
                setStudies(rows);
                if (rows.length > 0) {
                    setFormData2({
                        name: "StudyName",
                        value: rows[0].studyName,
                    });
                }
            })
            .catch(() => {
                setStudies([]);
            });

        apiFetchJson("/api/info/trainee")
            .then((data) => {
                const rows = Array.isArray(data?.db) ? data.db : [];
                setTrainees(rows);
            })
            .catch(() => {
                setTrainees([]);
            });

        apiFetchJson("/api/info/supervisor")
            .then((data) => {
                const rows = Array.isArray(data?.db) ? data.db : [];
                setSupervisors(rows);
            })
            .catch(() => {
                setSupervisors([]);
            });
    }

    useEffect(() => {
        refresh();
    }, []); // Empty dependents array - will only run once

    const handleSubmit = (event) => {
        event.preventDefault();
        // setSubmitting(true);

        // "TODO submiting new study"

        // fetch("/api/submitDBInsert", {
        //   method: "POST",
        //   headers: {
        //     "Content-type": "application/json",
        //   },
        //   body: JSON.stringify(formData),
        // })
        //   .then((res) => res.json())
        //   .then((res) => console.log(res))
        //   .then(() => {
        //     setSubmitting(false);
        //     setFormData({ reset: true });
        //   })
        //   .catch((error) => console.log(error));
    };

    const handleSubmit2 = (event) => {
        event.preventDefault();
        // setSubmitting(true);
        console.log("Submiting assign trainees/supervisors to study");
        if (checkedTrainees.length > 0) {
            formData2.checkedDBSubjs = checkedTrainees;
            formData2.dbType = 'Trainee';
        } else if (checkedSupervisors.length > 0) {
            formData2.checkedDBSubjs = checkedSupervisors;
            formData2.dbType = 'Supervisor';
        }
        // console.log('formdata2', formData2);
        apiFetchJson("/api/assignStudyToUSERS", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify(formData2),
        })
            .then((res) => console.log(res))
            .then(() => {
                setSubmitting(false);
                setFormData2({ reset: true });
            })
            .catch((error) => console.log(error));
    };

    const handleChange = (event) => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        });
    };
    const handleChange2 = (event) => {
        setFormData2({
            name: event.target.name,
            value: event.target.value,
        });
    };
    const handleCheckboxChangeT = (event) => {
        const target = event.target;
        const checked = target.checked;
        const ID = target.name;
        if (checked) {
            setCheckedTrainees((checkedTrainees) => [...checkedTrainees, ID]);
        } else {
            setCheckedTrainees((checkedTrainees) =>
                checkedTrainees.filter((iiID) => iiID !== ID)
            );
        }
    };
    const handleCheckboxChangeS = (event) => {
        const target = event.target;
        const checked = target.checked;
        const ID = target.name;
        if (checked) {
            setCheckedSupervisors((checkedSupervisors) => [...checkedSupervisors, ID]);
        } else {
            setCheckedSupervisors((checkedSupervisors) =>
                checkedSupervisors.filter((iiID) => iiID !== ID)
            );
        }
    };

    return (
        <Container>
            <h1>Manage studies and trainees</h1>
            {submitting && (
                <div>
                    You are submitting:
                    <ul>
                        {Object.entries(formData).map(([name, value]) => (
                            <li key={name}>
                                <strong>{name}</strong>: {value.toString()}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="col-lg-3">
                <Button className="my-3" onClick={refresh}>
                    Refresh
                </Button>
            </div>
            <Row className="my-3 border border-dark">
                <Form onSubmit={handleSubmit} disabled={submitting}>
                    <Form.Group>
                        <Form.Label>
                            Study name
                            <Form.Control
                                type="textarea"
                                name="studyName"
                                onChange={handleChange}
                                value={formData.studyName || ""}
                            />
                        </Form.Label>
                        <Form.Label className="mx-3">
                            Date start
                            <Form.Control
                                type="textarea"
                                name="studyStartDate"
                                onChange={handleChange}
                                value={formData.studyStartDate || ""}
                            />
                        </Form.Label>
                        <Form.Label className="mx-3">
                            Date end
                            <Form.Control
                                type="textarea"
                                name="studyEndDate"
                                onChange={handleChange}
                                value={formData.studyEndDate || ""}
                            />
                        </Form.Label>
                    </Form.Group>
                    <Button type="submit" disabled={submitting} className="m-3">
                        Submit
                    </Button>
                </Form>
            </Row>

            <Row className="border border-dark">
                <Form
                    onSubmit={handleSubmit2}
                    disabled={submitting}
                    encType="multiprt/form-data"
                >
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridStudy">
                            <Form.Label>Study</Form.Label>
                            <Form.Select
                                name="StudyName"
                                onChange={handleChange2}
                                value={formData2.StudyName || ""}
                            >
                                {studies.map((iStudy) => (
                                    <option value={iStudy.studyName} key={iStudy.studyID}>
                                        {iStudy.studyName}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridNSimulation">
                            <Form.Label>Number of simulations</Form.Label>
                            <Form.Control
                                type="textarea"
                                name="nSimulations"
                                onChange={handleChange2}
                                value={formData2.nSimulations || "0"}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridVesselType">
                            <Form.Label>Vessel type</Form.Label>
                            <Form.Control
                                type="textarea"
                                name="VesselType"
                                onChange={handleChange2}
                                value={formData2.VesselType || "2mm Silicon"}
                            />
                        </Form.Group>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Trainees</Form.Label>
                                {trainees.map((iTrainee) => (
                                    <div key={"Trainee-" + iTrainee.id} className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id={iTrainee.id}
                                            name={iTrainee.id}
                                            label={iTrainee.name}
                                            onChange={handleCheckboxChangeT}
                                        />
                                    </div>
                                ))}
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Supervisors</Form.Label>
                                {supervisors.map((iSupervisor) => (
                                    <div key={"Supervisor-" + iSupervisor.id} className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id={iSupervisor.id}
                                            name={iSupervisor.id}
                                            label={iSupervisor.name}
                                            onChange={handleCheckboxChangeS}
                                        />
                                    </div>
                                ))}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Button className="m-3" disabled={submitting} type="submit">
                        Submit
                    </Button>
                </Form>
            </Row>
        </Container>
    );
};

export default AssignStudies;
